<style>

    .jl{
        margin-left: 10px;
    }

</style>
<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="gasStation/findGasStationAdminList.action"
                        ref="GasStationListTable">
            <template slot="search">

              <el-row>
                <el-form :inline="true" class="demo-form-inline">
                  <el-form-item>
                    <el-select @change="$refs.GasStationListTable.search()" clearable placeholder="审核状态"
                               v-model="queryParams.status">
                      <el-option :value="1" label="待审核"></el-option>
                      <el-option :value="2" label="已通过"></el-option>
                      <el-option :value="3" label="已驳回"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select  @change="$refs.GasStationListTable.search()" clearable placeholder="上架状态"
                                v-model="queryParams.gasStatus">
                      <el-option :value="1" label="已上架"></el-option>
                      <el-option :value="2" label="已下架"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-date-picker

                        @change="onDateTimeChange"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        type="datetimerange"
                        v-model="queryParams.startEndTime">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-input placeholder="油站名称/负责人手机号" v-model="queryParams.keyword"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="$refs.GasStationListTable.search()" type="primary">搜索</el-button>
                  </el-form-item>

                </el-form>
              </el-row>

            </template>
            <template slot="item">
                <el-table-column
                        label="油站名称"
                        prop="gasStationName">
                </el-table-column>
                <el-table-column
                        label="省市区"
                        prop="city">
                </el-table-column>
                <el-table-column
                        label="油站地址"
                        prop="detailAddress">
                </el-table-column>

                <el-table-column
                        label="平台类型"
                        v-if="queryParams.channelId+'' == 'undefined'  ">
                            <template scope="scope">
                              {{ scope.row.externalType| typeFilter }}
                            </template>
                </el-table-column>

                <el-table-column
                        label="负责人">
                    <template scope="scope">
                        <el-row>
                            <el-col>
                                <span>{{ scope.row.stationmasterName }}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <span>{{ scope.row.stationmasterPhone }}</span>
                            </el-col>
                        </el-row>

                    </template>
                </el-table-column>

                <el-table-column
                        label="审核状态"
                        prop="status">
                    <template scope="scope">
              <span style="color:#fcb205" v-if="scope.row.status == 1">
                      待审核
                  </span>
                   <span  v-if="scope.row.status == 2">
                       已通过
                  </span>
                        <span style="color:red;"  v-if="scope.row.status == 3">
                         已驳回
                  </span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="上架状态"
                        prop="gasStatus">
                    <template scope="scope">
              <span style="color:#fcb205" v-if="scope.row.gasStatus == 1">
                        已上架
                  </span>
                        <span v-if="scope.row.gasStatus == 2" style="color: red;">
                        已下架
                  </span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="邀请人"
                        prop="inviterName">
                    <template scope="scope">
                        <el-row>
                            <el-col>
                                <span>{{ scope.row.inviterName }}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <span>{{ scope.row.inviterPhone }}</span>
                            </el-col>
                        </el-row>

                    </template>
                </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createDate">
                    <template scope="scope">
                        {{ scope.row.createDate| dateTimeFormat }}
                    </template>
                </el-table-column>

                <el-table-column
                        label="操作" width="150px">
                    <template scope="scope">
                        <el-dropdown trigger="click">
                            <el-button class="el-dropdown-link" size="mini" type="primary">
                                更多操作<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">

                                <el-dropdown-item @click.native="$router.push({path:'/home/stationAuthInfoDetail', query: { id: scope.row.id }})">
                                    查看
                                </el-dropdown-item>
                                <el-dropdown-item @click.native.prevent="showAuthStatus(scope.row.id)" >审核</el-dropdown-item>
                                <el-dropdown-item v-if="scope.row.gasStatus == 1" @click.native.prevent="changeGasStatus(scope.row.id,'下架',2)" >下架</el-dropdown-item>
                                <el-dropdown-item v-if="scope.row.gasStatus == 2"  @click.native.prevent="changeGasStatus(scope.row.id,'上架',1)" >上架</el-dropdown-item>
                                <el-dropdown-item @click.native="$router.push({path:'/home/stationAuthInfoModify', query: { id: scope.row.id }})">
                                    修改
                                </el-dropdown-item>
                                <el-dropdown-item @click.native.prevent="showGasOrderData(scope.row.id)" >查看订单数据</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </template>
        </table-template>
        <el-dialog :visible.sync="dialogAuthStatusFormVisible" label-width="80px" title="您正在进行信息审核！"
                               width="40%">

        <el-form :model="dialogAuthStatusForm" label-position="left" ref="dialogAuthStatusForm">
            <el-form-item label="审核">
                <el-radio-group @change="changeStatusInfo()"   v-model="dialogAuthStatusForm.authStatus">
                    <el-radio :label="2">通过</el-radio>
                    <el-radio  :label="3">不通过</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="原因" label-width="40px" v-if="isShowSendInfo">
                <el-input :rows="4" @input="isSendInfo()" placeholder="请输入操作理由" size="medium"
                          type="textarea"
                          v-model="dialogAuthStatusForm.remark"></el-input>
            </el-form-item>
            <el-form-item v-if="isShowSendInfo">

                <el-checkbox @change="isSendInfo()" style="" v-model="dialogAuthStatusForm.isSend">发送短信
                </el-checkbox>
                <span style="color:red;">{{ dialogAuthStatusForm.sendInfo }}</span>

            </el-form-item>

        </el-form>
        <div class="dialog-footer" slot="footer">

            <el-button @click="authStatus()" type="primary">确认无误</el-button>
        </div>
    </el-dialog>

        <el-dialog :visible.sync="dialogGasOrderFormVisible" label-width="80px" title="查看订单数据"
                   width="50%">
            <el-row>

                <el-date-picker type="datetimerange" v-model="dialogGasOrderForm.startEndTime" start-placeholder="开始时间" placeholder="按发布时间筛选" end-placeholder="结束时间" @change="loadGasOrderData()">
                </el-date-picker>

            </el-row>

            <el-table :data="datas" class="basic-margin" style="width: 100%">
                <el-table-column label="订单数量">
                    <template scope="scope">
                        {{scope.row.orderCount}}
                    </template>
                </el-table-column>
                <el-table-column label="加油总金额(元)">
                        <template scope="scope">
                            {{scope.row.gasAmount/100}}
                        </template>
                </el-table-column>
                <el-table-column label="累计优惠金额(元)">
                    <template scope="scope">
                        {{scope.row.discountAmount/100}}
                    </template>
                </el-table-column>
                <el-table-column label="累计代收服务费(元)">
                    <template scope="scope">
                        {{scope.row.serviceAmount/100}}
                    </template>
                </el-table-column>
                <el-table-column label="累计实付金额(元)">
                    <template scope="scope">
                        {{scope.row.paymentAmount/100}}
                    </template>
                </el-table-column>

            </el-table>

            <row>
                <br>
                提示：累计实付金额=加油总金额-累计优惠金额+累计代收服务费
            </row>

        </el-dialog>

    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import dbtGasStationModel from '@/framework/models/dbtGasStationModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'GasStationList',
  data: function () {
    return {
      datas: null,
      isShowSendInfo: false,
      queryParams: {
        gasStatus: 1

      },
      dialogAuthStatusForm: {
        isSend: false,
        authStatus: 2,
        remark: null

      },
      dialogAuthStatusFormVisible: false,
      dialogGasOrderForm: {
        startTime: null,
        endTime: null,
        id: null
      },
      dialogGasOrderFormVisible: false
    }
  },
  methods: {
    changeGasStatus: function (id, text, gasStatus) {
      this.$confirm('确认' + text + '该油站吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          id: id,
          gasStatus: gasStatus
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              message: text + '成功！',
              type: 'success'
            })
            _this.$refs.GasStationListTable.search()
          }
        }
        dbtGasStationModel.changeGasStatus(_this, params, listener)
      })
    },
    changeStatusInfo: function () {
      let authStatus = this.dialogAuthStatusForm.authStatus
      if (authStatus === 2) {
        this.isShowSendInfo = false
      } else {
        this.isShowSendInfo = true
      }
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.GasStationListTable.search()
    },
    showAuthStatus: function (id) {
      this.dialogAuthStatusFormVisible = true
      this.dialogAuthStatusForm.id = id
      this.dialogAuthStatusForm.sendInfo = null
    },
    showGasOrderData: function (id) {
      this.dialogGasOrderForm.id = id
      this.loadGasOrderData()
      this.dialogGasOrderFormVisible = true
    },
    isSendInfo: function () {
      if (this.dialogAuthStatusForm.isSend && this.dialogAuthStatusForm.remark) {
        this.dialogAuthStatusForm.sendInfo = '抱歉，您的油站入驻申请未通过审核，备注：' + this.dialogAuthStatusForm.remark
      } else {
        this.dialogAuthStatusForm.sendInfo = ''
      }
    },
    authStatus: function () {
      let that = this
      let param = { id: this.dialogAuthStatusForm.id, status: this.dialogAuthStatusForm.authStatus }
      if (this.dialogAuthStatusForm.authStatus === 3 && this.dialogAuthStatusForm.isSend) {
        if (!this.dialogAuthStatusForm.remark) {
          that.$message({
            message: '不通过理由不能为空！',
            type: 'error'
          })
          return
        }
        param.sendInfo = this.dialogAuthStatusForm.remark
      } else {
        param.sendInfo = null
      }

      let listener = {
        success: function (dataInfo) {
          that.dialogAuthStatusFormVisible = false
          that.$refs.GasStationListTable.search()
        }
      }
      dbtGasStationModel.authStation(that, param, listener)
    },
    loadGasOrderData: function () {
      let _this = this
      let params = {
        id: this.dialogGasOrderForm.id
      }

      if (_this.dialogGasOrderForm.startEndTime && _this.dialogGasOrderForm.startEndTime.length === 2) {
        let startTime = _this.dialogGasOrderForm.startEndTime[0]
        let endTime = _this.dialogGasOrderForm.startEndTime[1]
        if (startTime) {
          params.startTime = startTime.getTime()
        }
        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.datas
        }
      }
      dbtGasStationModel.selectGasOrderData(this, params, listener)
    }
  },
  filters: {
    authStatusFilter (value) {
      // 状态:1-待审核2-已通过 3-已驳回
      let filterValue = '状态不明确'
      switch (value) {
        case 1:
          filterValue = '待审核'
          break
        case 2:
          filterValue = '已通过'
          break
        case 3:
          filterValue = '已驳回'
          break
      }
      return filterValue
    },
    typeFilter (value) {
      // 状态:1-待审核2-已通过 3-已驳回
      let filterValue = '省心加油'
      switch (value) {
        case 1:
          filterValue = '省心加油'
          break
        case 2:
          filterValue = '易加油'
          break
        case 3:
          filterValue = '小桔加油'
          break
        case 4:
          filterValue = '团油'
          break
      }
      return filterValue
    }
  }
}
</script>

<style scoped>
</style>
